(function(){
  // LANG patch for en_au
  (function(){var tries=0;function patch(){typeof LANG_NAMES!="undefined"&&typeof CHECKOUT_LOCALE_MAP!="undefined"?(LANG_NAMES.en_au||(LANG_NAMES.en_au="EN"),CHECKOUT_LOCALE_MAP.en_au||(CHECKOUT_LOCALE_MAP.en_au="en"),typeof mskUpdateSwitcher=="function"&&mskUpdateSwitcher(),typeof mskUpdateCheckoutLinks=="function"&&mskUpdateCheckoutLinks()):tries<50&&(tries++,setTimeout(patch,100))}patch()
  })();

  // Detect market: country code, currency, OR URL prefix (indexOf avoids regex escape issues)
  var country = window.MSK_COUNTRY || '';
  var curr    = window.MSK_CURRENCY || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  var path    = window.location.pathname;
  var isAU = (country==='AU'||country==='NZ'||curr==='AUD'||curr==='NZD'||path.indexOf('/en-au')===0||path.indexOf('/en-nz')===0);
  var isUK = (country==='GB'||curr==='GBP'||path.indexOf('/en-gb')===0);
  if (!isAU && !isUK) return;

  var AU_SYM = 'A$';  var UK_SYM = '£';
  // Marge commerciale UK : SOURCE UNIQUE = MskPrice.commercialAdjust (assets/msk-price.js).
  function ukMargin(gbp){ return (window.MskPrice) ? window.MskPrice.commercialAdjust(gbp, 'GBP') : gbp * 1.1111; }

  function patchGlobals() {
    if (typeof mskCurrencySymbol === 'function') {
      window.mskCurrencySymbol = function() { if (isUK) return '£'; return '€'; };
    }
    if (typeof mskIsUK === 'function') {
      window.mskIsUK = function() { return isUK; };
    }
  }
  patchGlobals();
  setTimeout(patchGlobals, 100);
  setTimeout(patchGlobals, 400);

  var euToUk={"22":"5","22.5":"5.5","23":"6","23.5":"6.5","24":"7","24.5":"7.5","25":"8","25.5":"8.5","26":"9","26.5":"9","27":"9.5","27.5":"10","28":"10.5","28.5":"11","29":"11","29.5":"11.5","30":"12","30.5":"12","31":"12.5","31.5":"13","32":"13","32.5":"13.5","33":"1","33.5":"1.5","34":"1.5","34.5":"2","35":"2.5","36":"3.5","36.5":"4","37":"4","37.5":"4.5","38":"5","38.5":"5.5","39":"6","39.5":"6.5","40":"6.5","40.5":"7","41":"7.5","41.5":"7.5","42":"8","42.5":"8.5","43":"9","43.5":"9.5","44":"9.5","44.5":"10","45":"10.5","46":"11.5","47":"12"};

  // Text review cards (homepage .reviews-grid)
  var reviews = isAU ? [
    {stars:'★★★★★',text:'"Amazing quality, exactly as shown. Arrived in 10 days to Melbourne. Very happy!"',author:"Liam T.",city:"Melbourne"},
    {stars:'★★★★★',text:'"Ordered twice, both times perfect. Incredible value. Highly recommend."',author:"Chloe R.",city:"Sydney"},
    {stars:'★★★★★',text:'"Super fast shipping to Brisbane. Sneakers look legit, great condition."',author:"Jake M.",city:"Brisbane"},
    {stars:'★★★★★',text:'"Great service. Shoes look exactly like the photos. Love them!"',author:"Emma W.",city:"Perth"},
    {stars:'★★★★★',text:'"Bought the Jordan 1s, quality is top notch. Delivered in under 2 weeks. Stoked!"',author:"Ben K.",city:"Auckland"}
  ] : [
    {stars:'★★★★★',text:'"Incredible quality, exactly as shown in the photos. Highly recommend!"',author:"James T.",city:"London"},
    {stars:'★★★★★',text:'"Super happy with my order, true to size. Already ordered a second pair."',author:"Marcus B.",city:"Manchester"},
    {stars:'★★★★★',text:'"Unbeatable value, customer service was great too."',author:"Danny A.",city:"Birmingham"},
    {stars:'★★★★☆',text:'"Beautiful pair, quality is top notch. Will definitely order again."',author:"Sarah D.",city:"Leeds"},
    {stars:'★★★★★',text:'"Second order from MySportKits. Always reliable, always top quality."',author:"Jack M.",city:"Liverpool"}
  ];

  // Photo review cards (#photo-reviews-grid)
  var photoReviews = isAU ? [
    {t:'"Amazing quality! Beautifully packaged with MySportKits card. 100% recommended!"',n:"Liam T. — Melbourne"},
    {t:'"Ordered for my daughter, she is absolutely thrilled! Perfect sneakers."',n:"Chloe R. — Sydney"},
    {t:'"Super fast shipping to Brisbane. Shoes look great, great condition."',n:"Jake M. — Brisbane"},
    {t:'"2nd purchase from MySportKits, always top! Beautiful white trainers."',n:"Emma W. — Perth"},
    {t:'"Received in excellent condition. My neighbour ordered after seeing mine!"',n:"Noah B. — Adelaide"},
    {t:'"Top quality for the price! Exactly as in the photos. Very satisfied."',n:"Sophie K. — Gold Coast"},
    {t:'"Perfect fit! Colour exactly as shown. Stoked with my purchase!"',n:"Tyler M. — Auckland"},
    {t:'"Beautiful! Perfect fit, careful packaging with thank you note."',n:"Mia S. — Christchurch"},
    {t:'"Received in perfect condition! Very well packaged. Already my 3rd order!"',n:"Ryan C. — Canberra"}
  ] : [
    {t:'"Received in excellent condition! Beautifully packaged with MySportKits card. 100% recommended!"',n:"Jack M. — Liverpool"},
    {t:'"Ordered for my daughter (size 5), she loves them! Immaculate trainers."',n:"Emma W. — Glasgow"},
    {t:'"Black/yellow TNs, great quality. Reliable shop, already my 3rd order!"',n:"Tom K. — Bristol"},
    {t:'"2nd purchase from MySportKits, always top quality! Beautiful white trainers."',n:"Sophie R. — Edinburgh"},
    {t:'"Received in excellent condition. My neighbour ordered after seeing mine!"',n:"James T. — London"},
    {t:'"TN are amazing, perfect sizing. The wait was worth it."',n:"Marcus B. — Manchester"},
    {t:'"Top quality for the price! Exactly as in the photos. Very satisfied."',n:"Danny A. — Birmingham"},
    {t:'"Beautiful! Perfect fit, careful packaging with thank you note."',n:"Sarah D. — Leeds"},
    {t:'"Perfect fit! Colour exactly as shown in photos. Really happy!"',n:"Ben H. — Cardiff"}
  ];

  var PRICE_SEL = [
    '.prod-price','.prod-compare-price',
    '.product-price','.product-compare-price',
    '.sticky-atc-price','.quick-shop-price',
    '#qs-price','#cart-total',
    '.cart-item-price','.cart-line-price','.item-price',
    '.cart-page-price','.cart-page-subtotal','.cart-summary-total strong'
  ].join(',');

  function convertEl(el, rate, sym) {
    var txt = el.textContent.trim();
    if (txt.indexOf(sym) === 0) return;
    var m = txt.match(/^€\s*([\d\s ]+(?:[,.]\d{1,2})?)\s*€?$/) ||
            txt.match(/^([\d\s ]+(?:[,.]\d{1,2})?)\s*€$/);
    if (!m) return;
    var eur = parseFloat(m[1].replace(/[\s ]/g,'').replace(',','.'));
    if (isNaN(eur) || eur <= 0) return;
    el.textContent = sym + Math.round(eur * rate);
  }

  function convertPrices() {
    // Conversion generique EUR -> devise active : DELEGUEE au module universel msk-price.js.
    // (plus aucune table de symboles / taux code en dur ici ; la marge UK reste dans fixUKProductPrices)
    if (window.MskPrice) window.MskPrice.sweep();
  }

  // UK only: multiply native £XX prices on product page (cart handled by theme.js)
  var PROD_PRICE_SEL = '.prod-price,.prod-compare-price,.product-price,.product-compare-price,.sticky-atc-price,.quick-shop-price,#qs-price';
  function fixUKProductPrices() {
    if (!isUK) return;
    document.querySelectorAll(PROD_PRICE_SEL).forEach(function(el) {
      var txt = el.textContent.trim();
      if (el.dataset.ukConverted === txt) return;
      var m = txt.match(/^£\s*([\d,]+(?:\.\d{1,2})?)$/);
      if (!m) return;
      var gbp = parseFloat(m[1].replace(/,/g,''));
      if (isNaN(gbp) || gbp <= 0) return;
      var result = '£' + Math.round(ukMargin(gbp));
      el.textContent = result;
      el.dataset.ukConverted = result;
    });
  }

  function fixAUProductPrices() {
    return; // Shopify Markets gère déjà la conversion EUR→AUD
  }

  // Photo section: tag, title, badges
  function fixPhotoTexts() {
    var pt = document.getElementById('photo-rv-tag');
    if (pt) pt.textContent = '📸 Verified reviews with photos';
    var ph = document.getElementById('photo-rv-title');
    if (ph) ph.textContent = 'THEY RECEIVED THEIR ORDER';
    document.querySelectorAll('.rv-badge').forEach(function(el) {
      el.textContent = '✓ Verified';
    });
  }

  // Photo review cards: update text + name
  function fixPhotoGrid() {
    fixPhotoTexts();
    var grid = document.getElementById('photo-reviews-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.rv-card');
    cards.forEach(function(card, i) {
      var rev = photoReviews[i % photoReviews.length];
      var txt = card.querySelector('.rv-text');
      if (txt) txt.textContent = rev.t;
      var nameEl = card.querySelector('.rv-name');
      if (nameEl) nameEl.textContent = rev.n;
      var badge = card.querySelector('.rv-badge');
      if (badge) badge.textContent = '✓ Verified';
    });
  }

  function fix(){
    var desc=document.querySelector('.product-desc');
    if(desc&&!desc.hasAttribute('data-en-done')){desc.textContent='Premium quality sneakers. Comfortable fit, durable materials. Ships worldwide in 7-14 business days.';desc.setAttribute('data-en-done','1');desc.classList.remove('product-desc');desc.classList.add('product-desc-en');}
    var lbl=document.getElementById('size-label-main');
    if(lbl&&!lbl.hasAttribute('data-label-done')){lbl.textContent='UK Size';lbl.setAttribute('data-label-done','1');lbl.id='size-label-en';}
    document.querySelectorAll('.size-btn:not([data-eu-size])').forEach(function(btn){var eu=btn.textContent.trim();if(euToUk[eu]!==undefined){btn.setAttribute('title','EU '+eu);btn.textContent=euToUk[eu];btn.setAttribute('data-eu-size',eu);}});
    var grid=document.querySelector('.reviews-grid');
    if(grid&&!grid.getAttribute('data-au-done')){grid.setAttribute('data-au-done','1');var html='';reviews.forEach(function(r){html+='<div class="review-card"><div class="review-stars">'+r.stars+'</div><div class="review-text">'+r.text+'</div><div class="review-author">'+r.author+' <span class="review-location">— '+r.city+'</span></div></div>';});grid.innerHTML=html;}
    convertPrices();
    fixUKProductPrices();
    fixAUProductPrices();
    fixPhotoGrid();
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(fix,0);});}else{setTimeout(fix,0);}
  setTimeout(fix, 400);
  setTimeout(fix, 800);
  setTimeout(fix, 1500);

  new MutationObserver(function(){ convertPrices(); fixUKProductPrices(); fixAUProductPrices(); }).observe(document.documentElement,{childList:true,subtree:true});

  var landingNames = isAU ? [
    "Liam T. — Melbourne","Chloe R. — Sydney","Jake M. — Brisbane",
    "Emma W. — Perth","Noah B. — Adelaide","Sophie K. — Gold Coast",
    "Tyler M. — Auckland","Mia S. — Christchurch"
  ] : [
    "James T. — London","Marcus B. — Manchester","Danny A. — Birmingham",
    "Sarah D. — Leeds","Jack M. — Liverpool","Emma W. — Glasgow",
    "Tom K. — Bristol","Sophie R. — Edinburgh"
  ];
  function fixLandingReviews(){
    var rvNames=document.querySelectorAll('.rv-name');
    if(!rvNames.length)return;
    rvNames.forEach(function(el,i){el.textContent=landingNames[i%landingNames.length];});
    fixPhotoTexts();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fixLandingReviews);}else{fixLandingReviews();}
  setTimeout(fixLandingReviews, 400);
  setTimeout(fixLandingReviews, 800);
  setTimeout(fixLandingReviews, 1500);
})();
